<div class="grid">
  <div class="md:col-6 col-12">
    <p-card
      header="Описание"
      styleClass="mt-3">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium required-field">Название</label>
          <crm-input-text
            [(value)]="data.name"
            [isError]="$any(errors?.name)"></crm-input-text>
          @if (errors?.name) {
            <small class="p-error">
              {{ errors.name | join }}
            </small>
          }
        </div>

        <div class="field">
          <label class="font-medium required-field">Тема письма</label>
          <crm-input-text
            [(value)]="data.title"
            [isError]="$any(errors?.title)"></crm-input-text>
          @if (errors?.title) {
            <small class="p-error">
              {{ errors.title | join }}
            </small>
          }
        </div>

        <div class="field">
          <label class="font-medium required-field">Текст сообщения</label>
          <crm-editor
            [(value)]="data.text"
            height="250px"></crm-editor>
          @if (errors?.text) {
            <small class="p-error">
              {{ errors.text | join }}
            </small>
          }
        </div>

        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Тип</label>
            <crm-single-select
              [options]="types"
              [(selectedItem)]="data.type"
              class="w-full {{ errors?.type ? 'ng-invalid ng-dirty' : '' }}"
              optionValue="name"
              [styleClass]="errors?.type ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | mailingTypeName }}
              </ng-template>
            </crm-single-select>
            @if (errors?.type) {
              <small class="p-error">
                {{ errors.type | join }}
              </small>
            }
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Канал</label>
            <crm-single-select
              [options]="channels"
              [(selectedItem)]="data.channel"
              (selectedItemChange)="changeChannel($event)"
              class="w-full {{ errors?.channel ? 'ng-invalid ng-dirty' : '' }}"
              optionValue="name"
              [styleClass]="errors?.channel ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | mailingChannelName }}
              </ng-template>
            </crm-single-select>
            @if (errors?.channel) {
              <small class="p-error">
                {{ errors.channel | join }}
              </small>
            }
          </div>

          @if (data.channel === MailingChannelEnum.SMS) {
            <div class="field lg:col-6 col-12">
              <label class="font-medium required-field">SMS сервис</label>
              <crm-newsletter-sms-sender-single-select
                [(smsSender)]="data.smsSender"
                [arraySms]="arraySms"
                [isError]="$any(errors?.smsSender)"
                [showClear]="true"></crm-newsletter-sms-sender-single-select>
              @if (errors?.smsSender) {
                <small class="p-error">
                  {{ errors.smsSender | join }}
                </small>
              }
            </div>
          }

          @if (data.channel === MailingChannelEnum.EMAIL) {
            <div class="field lg:col-6 col-12">
              <label class="font-medium required-field">Тип почтового сервиса</label>
              <p-selectButton
                [options]="emailOptions"
                [(ngModel)]="data.emailSender.gate"
                (ngModelChange)="changeEmailType($event)">
              </p-selectButton>
            </div>

            @if (data.emailSender.gate === EmailGateEnum.FRM) {
              <div class="field lg:col-6 col-12">
                <label class="font-medium required-field">Email сервис</label>
                <crm-newsletter-email-sender-single-select
                  [(email)]="data.emailSender.email"
                  [emails]="emails"
                  [isError]="$any(errors?.emailSender)"
                  [showClear]="true"></crm-newsletter-email-sender-single-select>
                @if (errors?.emailSender) {
                  <small class="p-error">
                    {{ errors.emailSender | join }}
                  </small>
                }
              </div>
            }

            @if (data.emailSender.gate === EmailGateEnum.MAIN_SMS) {
              <div class="field lg:col-6 col-12">
                <label class="font-medium required-field">MainSMS сервис</label>
                <crm-newsletter-email-main-sms-sender-single-select
                  [(email)]="data.emailSender.mainSmsAccount"
                  (emailChange)="changeEmailMainSms($event)"
                  [emails]="arraySms"
                  [isError]="$any(errors?.emailSender)"
                  [showClear]="true"></crm-newsletter-email-main-sms-sender-single-select>
                @if (errors?.emailSender) {
                  <small class="p-error">
                    {{ errors.emailSender | join }}
                  </small>
                }
              </div>

              @if (data.emailSender.mainSmsAccount) {
                <div class="field lg:col-6 col-12">
                  <label class="font-medium required-field">Email</label>
                  <crm-single-select
                    [options]="data.emailSender.mainSmsAccount.emails"
                    [(selectedItem)]="data.emailSender.mainSmsAccountEmail"
                    class="w-full {{ errors?.emailSender ? 'ng-invalid ng-dirty' : '' }}"
                    optionValue="name"
                    [styleClass]="errors?.emailSender ? 'ng-invalid ng-dirty' : ''"
                    [filter]="false"
                    [showClear]="true"
                    appendTo="body">
                  </crm-single-select>
                  @if (errors?.emailSender) {
                    <small class="p-error">
                      {{ errors.emailSender | join }}
                    </small>
                  }
                </div>
              }
            }
          }
        </div>

        @if (data.type === MailingTypeEnum.DEBTORS) {
          <ng-template
            [ngTemplateOutlet]="reusableTemplate"
            [ngTemplateOutletContext]="{ data: data }"></ng-template>
        }

        @if ([MailingTypeEnum.DEBTORS_FROM_FILE].includes($any(data.type))) {
          <div class="field">
            <label class="font-medium required-field">Файл</label>
            <crm-file-uploader
              [isUploadFiles]="false"
              [uploadingFiles]="loadingFile"
              (filesSelected)="selectedFileDebtor($event)"
              label="Файл"></crm-file-uploader>
            @if (errors?.fileDebtorTargets) {
              <small class="p-error">
                {{ errors.fileDebtorTargets | join }}
              </small>
            }
          </div>
        }

        @if ([MailingTypeEnum.DEBTORS_FROM_FILE, MailingTypeEnum.DEBTORS].includes($any(data.type))) {
          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="data.includingAdvancePayment"
              [binary]="true"
              inputId="includingAdvancePayment"></p-checkbox>
            <label [for]="'includingAdvancePayment'">С учетом аванс</label>
          </div>
        }

        @if (data.type === MailingTypeEnum.DEBTORS && data.channel === MailingChannelEnum.EMAIL) {
          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="data.attachBills"
              [binary]="true"
              inputId="attachBills"></p-checkbox>
            <label [for]="'attachBills'">Отправлять счета</label>
          </div>

          @if (data.attachBills) {
            <ng-template
              [ngTemplateOutlet]="periodFilter"
              [ngTemplateOutletContext]="{ data: data }"></ng-template>
            <ng-template
              [ngTemplateOutlet]="attachmentStatusFilter"
              [ngTemplateOutletContext]="{ data: data }"></ng-template>
            <ng-template
              [ngTemplateOutlet]="billingPaymentStatusesFilter"
              [ngTemplateOutletContext]="{ data: data }"></ng-template>
          }
        }
      </div>
    </p-card>

    @if (data.type === MailingTypeEnum.BILLS && (!canDelete || (canDelete && data.bills?.length))) {
      <div class="mt-3">
        <p-card header="Поиск счетов">
          <ng-template
            [ngTemplateOutlet]="reusableTemplate"
            [ngTemplateOutletContext]="{ data: data }"></ng-template>

          <h3 class="font-medium -mb-2">Счета</h3>
          <p-divider></p-divider>

          <div class="flex align-items-center gap-3">
            @if (!canDelete) {
              <crm-button
                label="Поиск счетов"
                icon="pi pi-search"
                [loading]="loadingBills"
                [disabled]="!data.attachmentStartDate || !data.attachmentEndDate"
                (onClick)="findBills()"></crm-button>
            }

            @if (bills?.length && !loadingBills && !canDelete) {
              <crm-button
                [label]="bills?.length === data.bills?.length ? 'Убрать все' : 'Выбрать все'"
                styleClass="p-button-text"
                (onClick)="toggleAllSelectedBill()"></crm-button>
            }
          </div>

          @if (bills?.length && !loadingBills && !canDelete) {
            <crm-table
              [columns]="billColumns"
              [values]="bills"
              scrollHeight="300px"
              styleClass="mt-3">
              <ng-template
                #rowTemplate
                let-bill="item">
                @if (toBill(bill); as bill) {
                  <tr>
                    <td>
                      <div class="flex align-items-center gap-3">
                        <div class="field-checkbox mb-0">
                          <p-checkbox
                            [ngModel]="!!(data.bills | findByKey: 'erp1cRef' : bill.erp1cRef)"
                            (ngModelChange)="toggleSelectedBill(bill)"
                            [binary]="true"
                            (click)="$event.stopPropagation()"></p-checkbox>
                        </div>
                        <div>{{ bill.erp1cNumber }}</div>
                      </div>
                    </td>
                    <td>
                      @if (bill.contragent) {
                        <a
                          routerLink="/client/contragent/card/{{ bill.contragent?.id }}"
                          target="_blank">
                          {{ bill.contragent?.name }}
                        </a>
                      }
                    </td>
                    <td>
                      {{ bill.directions | join: 'name' }}
                    </td>
                    <td>
                      {{ bill.amount | number: '.0-0' }}
                    </td>
                    <td>
                      {{ bill.lastSentViaMailing ? 'Отправлен' : 'Не отправлен' }}
                    </td>
                  </tr>
                }
              </ng-template>
            </crm-table>
          }

          @if (canDelete) {
            <crm-table
              [columns]="billColumns"
              [values]="data.bills"
              scrollHeight="300px">
              <ng-template
                #rowTemplate
                let-bill="item">
                @if (toBill(bill); as bill) {
                  <tr>
                    <td>
                      {{ bill.erp1cNumber }}
                    </td>
                    <td>
                      @if (bill.contragent) {
                        <a
                          routerLink="/client/contragent/card/{{ bill.contragent?.id }}"
                          target="_blank">
                          {{ bill.contragent?.name }}
                        </a>
                      }
                    </td>
                    <td>
                      {{ bill.directions | join: 'name' }}
                    </td>
                    <td>
                      {{ bill.amount | number: '.0-0' }}
                    </td>
                    <td>
                      {{ bill.lastSentViaMailing ? 'Отправлен' : 'Не отправлен' }}
                    </td>
                  </tr>
                }
              </ng-template>
            </crm-table>
          }
        </p-card>
      </div>
    }

    @if (data.type === MailingTypeEnum.DOCUMENTS && (!canDelete || (canDelete && data.documents?.length))) {
      <div class="mt-3">
        <p-card header="Поиск документов">
          <ng-template
            [ngTemplateOutlet]="reusableTemplate"
            [ngTemplateOutletContext]="{ data: data }"></ng-template>

          <h3 class="font-medium -mb-2">Документы</h3>
          <p-divider></p-divider>

          <div class="flex align-items-center gap-3">
            @if (!canDelete) {
              <crm-button
                label="Поиск документов"
                icon="pi pi-search"
                [loading]="loadingDocuments"
                [disabled]="!data.attachmentStartDate || !data.attachmentEndDate"
                (onClick)="findDocuments()"></crm-button>
            }

            @if (documents?.length && !loadingDocuments && !canDelete) {
              <crm-button
                [label]="documents?.length === data.documents?.length ? 'Убрать все' : 'Выбрать все'"
                styleClass="p-button-text"
                (onClick)="toggleAllSelectedDocuments()"></crm-button>
            }
          </div>

          @if (documents?.length && !loadingDocuments && !canDelete) {
            <crm-table
              [columns]="documentColumns"
              [values]="documents"
              styleClass="mt-3"
              scrollHeight="300px">
              <ng-template
                #rowTemplate
                let-document="item">
                @if (toDocument(document); as document) {
                  <tr>
                    <td>
                      <div class="flex align-items-center gap-3">
                        <div class="field-checkbox mb-0">
                          <p-checkbox
                            [ngModel]="!!(data.documents | findByKey: 'erp1cRef' : document.erp1cRef)"
                            (ngModelChange)="toggleSelectedDocument(document)"
                            [binary]="true"
                            (click)="$event.stopPropagation()"></p-checkbox>
                        </div>
                        <div>{{ document.externalCode }}</div>
                      </div>
                    </td>
                    <td>
                      @if (document.contragent) {
                        <a
                          routerLink="/client/contragent/card/{{ document.contragent?.id }}"
                          target="_blank">
                          {{ document.contragent?.name }}
                        </a>
                      }
                    </td>
                    <td>
                      {{ document.amount | number: '.0-0' }}
                    </td>
                    <td>
                      {{ document.lastSentViaMailing ? 'Отправлен' : 'Не отправлен' }}
                    </td>
                  </tr>
                }
              </ng-template>
            </crm-table>
          }

          @if (canDelete) {
            <crm-table
              [columns]="documentColumns"
              [values]="data.documents"
              scrollHeight="300px">
              <ng-template
                #rowTemplate
                let-document="item">
                @if (toDocument(document); as document) {
                  <tr>
                    <td>
                      {{ document.externalCode }}
                    </td>
                    <td>
                      @if (document.contragent) {
                        <a
                          routerLink="/client/contragent/card/{{ document.contragent?.id }}"
                          target="_blank">
                          {{ document.contragent?.name }}
                        </a>
                      }
                    </td>
                    <td>
                      {{ document.amount | number: '.0-0' }}
                    </td>
                    <td>
                      {{ document.lastSentViaMailing ? 'Отправлен' : 'Не отправлен' }}
                    </td>
                  </tr>
                }
              </ng-template>
            </crm-table>
          }
        </p-card>
      </div>
    }

    <div class="mt-3">
      <p-card header="Планирование">
        <div class="field lg:col-6 col-12">
          <label class="font-medium required-field">Дата и время создания</label>
          <crm-datepicker
            [(value)]="data.date"
            [showTime]="true"
            styleClass="w-full"
            [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
            appendTo="body"></crm-datepicker>
          @if (errors?.date) {
            <small class="p-error">
              {{ errors.date | join }}
            </small>
          }
        </div>
      </p-card>
    </div>
  </div>

  <div class="md:col-6 col-12">
    <p-card
      header="Аудиторы"
      styleClass="md:mt-3">
      <div class="formgrid grid">
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Пользователи</label>
          <crm-user-multi-select
            [(selectedUsers)]="data.userAuditors"
            [isError]="$any(errors?.userAuditors)"
            [isFloatLabel]="false"
            appendTo="body"></crm-user-multi-select>
          @if (errors?.userAuditors) {
            <p class="p-error">
              {{ errors.userAuditors | join }}
            </p>
          }
        </div>
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Группы</label>
          <crm-user-group-multi-select
            [(selectedUserGroups)]="data.groupAuditors"
            [isFloatLabel]="false"
            [class]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.groupAuditors ? 'ng-invalid ng-dirty' : ''"
            appendTo="body">
          </crm-user-group-multi-select>
          @if (errors?.groupAuditors) {
            <p class="p-error">
              {{ errors.groupAuditors | join }}
            </p>
          }
        </div>
      </div>
    </p-card>

    @if (data.type === MailingTypeEnum.HELPDESK) {
      <p-card
        header="Участники рассылки"
        styleClass="md:mt-3">
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium required-field">Внешние пользователи</label>
            <crm-multi-select
              [(selectedItems)]="data.externalUsers"
              [options]="externalUsers"
              [class]="errors?.externalUsers ? 'ng-invalid ng-dirty' : ''"
              [showToggleAll]="true"
              optionLabel="profile.name"
              [styleClass]="errors?.externalUsers ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-multi-select>
            @if (errors?.externalUsers) {
              <p class="p-error">
                {{ errors.externalUsers | join }}
              </p>
            }
          </div>
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [users]="recipientUsers"
              [(selectedUsers)]="data.recipientUsers"
              [isError]="$any(errors?.recipientUsers)"
              [customRequest]="true"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
            @if (errors?.recipientUsers) {
              <p class="p-error">
                {{ errors.recipientUsers | join }}
              </p>
            }
          </div>
        </div>
      </p-card>
    }

    @if (data.type === MailingTypeEnum.DEBTORS_FROM_FILE) {
      <p-card
        header="Участники рассылки"
        styleClass="mt-3">
        @if (errors?.fileDebtorTargets) {
          <div>
            <small class="p-error">
              {{ $any(errors.fileDebtorTargets) | joinWithChild }}
            </small>
          </div>
        }

        @if (!data.fileDebtorTargets?.length) {
          <p class="text-xl font-bold">
            Список участников пустой
          </p>
        }

        @if (data.fileDebtorTargets?.length) {
          <crm-table
            name="newsletter.form.contacts"
            [columns]="columns"
            [values]="data.fileDebtorTargets"
            [scrollable]="true"
            scrollHeight="300px"
            styleClass="p-datatable-sm">
            <ng-template
              #rowTemplate
              let-target="item">
              @if (toItemContactFromFile(target); as target) {
                <tr>
                  <td [ngStyle]="{ 'min-width.px': 140 }">
                    {{ target?.name }}
                  </td>
                  <td [ngStyle]="{ 'min-width.px': 140 }">
                    <div>
                      @if (data.channel === MailingChannelEnum.EMAIL) {
                        @if (target?.email) {
                          <div>
                            <a href="mailto:{{ target?.email }}">{{ target?.email }}</a>
                          </div>
                        } @else {
                          <p class="text-gray-400">Нет email</p>
                        }
                      }
                      @if (data.channel === MailingChannelEnum.SMS) {
                        @if (target.phone) {
                          <div>
                            <a href="tel:{{ target?.phone }}">{{ target?.phone | phone }}</a>
                          </div>
                        } @else {
                          <p class="text-gray-400">Нет телефона</p>
                        }
                      }
                    </div>
                  </td>
                  <td [ngStyle]="{ 'min-width.px': 100, 'max-width.px': 100 }">
                    {{ target.amount | number: '.0-0' }}
                  </td>
                  <td [ngStyle]="{ 'max-width.px': 35, 'min-width.px': 35 }">
                    <i
                      class="pi pi-times cursor-pointer hover:text-red-300 text-red-500"
                      style="font-size: 1.5rem"
                      (click)="deleteContragentFromFile(target)"></i>
                  </td>
                </tr>
              }
            </ng-template>
          </crm-table>
        }
      </p-card>
    }

    @if (canDelete) {
      <crm-newsletter-history-widget
        [newsletterId]="getNewsletterId"
        class="block mt-3"></crm-newsletter-history-widget>
    }
  </div>
</div>

@if (canWrite) {
  <div class="grid mt-3">
    <div class="md:col-6 col-12 flex flex-wrap justify-content-between">
      <div>
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success mr-2"
          (onClick)="onSave(data)"></crm-button>
        @if (!isModal) {
          <crm-go-back-button
            [route]="route"></crm-go-back-button>
        }
      </div>
      @if (canDelete) {
        <crm-button
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="delete.emit(data)"></crm-button>
      }
    </div>
  </div>
}

<ng-template
  #reusableTemplate
  let-data="data">
  @if (toData(data); as data) {
    <div class="formgrid grid">
      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <ng-template
          [ngTemplateOutlet]="periodFilter"
          [ngTemplateOutletContext]="{ data: data }"></ng-template>
      }

      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Бюджетная статья</label>
          <crm-direction-multi-select
            [directions]="directions"
            [(selectedDirections)]="data.billingDirections"
            [styleClass]="errors?.billingDirections ? 'ng-invalid ng-dirty' : ''"
            [class]="errors?.billingDirections ? 'ng-invalid ng-dirty' : ''"
            placeholder=""
            appendTo="body"></crm-direction-multi-select>
          @if (errors?.billingDirections) {
            <small class="p-error">
              {{ errors?.billingDirections | join }}
            </small>
          }
        </div>
      }

      @if ([MailingTypeEnum.BILLS].includes($any(data.type))) {
        <ng-template
          [ngTemplateOutlet]="billingPaymentStatusesFilter"
          [ngTemplateOutletContext]="{ data: data }"></ng-template>
      }

      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DEBTORS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <div class="field lg:col-6 col-12">
          <label
            class="font-medium"
            [class.required-field]="data.type === MailingTypeEnum.DEBTORS">
            Компания
          </label>
          <crm-company-multi-select
            [(selectedCompanies)]="data.companies"
            [class]="errors?.companies ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.companies ? 'ng-invalid ng-dirty' : ''"
            [isFloatLabel]="false"
            appendTo="body"></crm-company-multi-select>
          @if (errors?.companies) {
            <small class="p-error">
              {{ errors.companies | join }}
            </small>
          }
        </div>
      }

      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DEBTORS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <div class="field lg:col-6 col-12">
          <label class="font-medium">Контрагент</label>
          <crm-contragent-multi-select
            [(selectedEntities)]="data.contragents"
            [isError]="$any(errors?.contragents)"
            appendTo="body"></crm-contragent-multi-select>
          @if (errors?.contragents) {
            <small class="p-error">
              {{ errors.contragents | join }}
            </small>
          }
        </div>
      }

      @if ([MailingTypeEnum.BILLS, MailingTypeEnum.DOCUMENTS].includes($any(data.type))) {
        <ng-template
          [ngTemplateOutlet]="attachmentStatusFilter"
          [ngTemplateOutletContext]="{ data: data }"></ng-template>
      }
    </div>
  }
</ng-template>

<ng-template
  #periodFilter
  let-data="data">
  <div class="field lg:col-6 col-12">
    <label class="font-medium required-field">Период</label>
    <crm-daterangepicker
      [value]="[data.attachmentStartDate, data.attachmentEndDate]"
      (changeValue)="setBillingPeriod($event)"
      appendTo="body"></crm-daterangepicker>
    @if (errors?.attachmentStartDate) {
      <small class="p-error">
        {{ errors?.attachmentStartDate | join }}
      </small>
    }
    @if (errors?.attachmentEndDate) {
      <small class="p-error">
        {{ errors?.attachmentEndDate | join }}
      </small>
    }
  </div>
</ng-template>

<ng-template
  #attachmentStatusFilter
  let-data="data">
  <div class="field lg:col-6 col-12">
    <label class="font-medium">Состояние</label>
    <crm-multi-select
      [options]="attachmentStatuses"
      [(selectedItems)]="data.attachmentStatuses"
      optionValue="name"
      display="comma"
      [styleClass]="errors?.attachmentStatuses ? 'ng-invalid ng-dirty' : ''"
      class="w-full {{ errors?.attachmentStatuses ? 'ng-invalid ng-dirty' : '' }}"
      [showHeader]="false"
      appendTo="body">
      <ng-template
        #selectedItemsTemplate
        let-statuses="items">
        @for (status of statuses; track $index; let isLast = $last) {
          {{ status?.value | mailingAttachmentStatusName }}{{ isLast ? '' : ', ' }}
        }
      </ng-template>
      <ng-template
        #itemTemplate
        let-status="item">
        {{ status.value | mailingAttachmentStatusName }}
      </ng-template>
    </crm-multi-select>
    @if (errors?.attachmentStatuses) {
      <small class="p-error">
        {{ errors.attachmentStatuses | join }}
      </small>
    }
  </div>
</ng-template>

<ng-template
  #billingPaymentStatusesFilter
  let-data="data">
  <div class="field lg:col-6 col-12">
    <label class="font-medium">Статус</label>
    <crm-multi-select
      [options]="billingPaymentStatuses"
      [(selectedItems)]="data.billingPaymentStatuses"
      class="w-full {{ errors?.billingPaymentStatuses ? 'ng-invalid ng-dirty' : '' }}"
      optionValue="name"
      [styleClass]="errors?.billingPaymentStatuses ? 'ng-invalid ng-dirty' : ''"
      [showHeader]="false"
      display="comma"
      appendTo="body">
      <ng-template
        #selectedItemsTemplate
        let-bills="items">
        @for (bill of bills; track $index; let isLast = $last) {
          {{ bill?.value | billPaymentStatusName }}{{ isLast ? '' : ', ' }}
        }
      </ng-template>
      <ng-template
        #itemTemplate
        let-bill="item">
        {{ bill.value | billPaymentStatusName }}
      </ng-template>
    </crm-multi-select>
    @if (errors?.billingPaymentStatuses) {
      <small class="p-error">
        {{ errors.billingPaymentStatuses | join }}
      </small>
    }
  </div>
</ng-template>
